/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ReportingPeriod,
} from '../models/index';
import {
    ReportingPeriodFromJSON,
    ReportingPeriodToJSON,
} from '../models/index';

/**
 * ReportingPeriodsApi - interface
 * 
 * @export
 * @interface ReportingPeriodsApiInterface
 */
export interface ReportingPeriodsApiInterface {
    /**
     * Returns all supported reporting periods for time-based queries
     * @summary Get supported reporting periods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingPeriodsApiInterface
     */
    getSupportedPeriodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReportingPeriod>>>;

    /**
     * Returns all supported reporting periods for time-based queries
     * Get supported reporting periods
     */
    getSupportedPeriods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReportingPeriod>>;

}

/**
 * 
 */
export class ReportingPeriodsApi extends runtime.BaseAPI implements ReportingPeriodsApiInterface {

    /**
     * Returns all supported reporting periods for time-based queries
     * Get supported reporting periods
     */
    async getSupportedPeriodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReportingPeriod>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/common/reporting-periods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReportingPeriodFromJSON));
    }

    /**
     * Returns all supported reporting periods for time-based queries
     * Get supported reporting periods
     */
    async getSupportedPeriods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReportingPeriod>> {
        const response = await this.getSupportedPeriodsRaw(initOverrides);
        return await response.value();
    }

}
